import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Divider,
  Grid,
} from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";

import { ExamProps } from "./Exam";
import CardHeader, { singleLineEllipsis } from "./layouts/CardHeader";
import CountChips from "./layouts/CountChips";
import CardFooter from "./layouts/CardFooter";
import { EllipsisText } from "./Goal";

const Subtopic: React.FC<any> = ({
  data,
  onclick,
  tempSelected,
  setCardsSelected,
  cardsSelected,child
}) => {
  const tempS = data.id === tempSelected?.data.id;
  return (
    <Card
         sx={{
        borderRadius: 3,
        boxShadow: tempS ? 4 : "none",
        transform: tempS ? "scale(1.01)" : "none",
        border: tempS ? "2px dashed #519C66" : "2px dashed #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: 4,
          transform: "scale(1.01)",
          border: "2px dashed #519C66",
        },
        pointerEvents: tempS ? "none" : "auto",
      }}
      onClick={onclick}
    >
      <CardContent>
        <CardHeader
          name={data.name}
            onClick={onclick}
            selected={child?true:false}
          description={data.description}
          id={data.id}
          status={data.status}
          is_active={data.is_active}
        />
        <Box
          display="flex"
          gap={1}
          flexWrap="wrap"
          mb={2}
          justifyContent={"flex-end"}
        >
          <Chip
                label={`LOD: ${data.lod_index || 0}`}
                size="small"
                sx={{
                  bgcolor: "#fef3c7",
                  color: "#92400e",
                  ...singleLineEllipsis,
                }}
              />
        </Box>
        {/* Stats Grid */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={6} sm={3}>
            <CountChips
              label="Clusters"onClick={
                tempS &&
                cardsSelected.goal &&
                cardsSelected.section &&
                cardsSelected.unit &&
                cardsSelected.topic&&
                cardsSelected.subtopic
                  ? () => {
                      if (cardsSelected.cluster) {
                        setCardsSelected({
                          cluster: false,
                          question: false,
                        });
                      } else {
                        setCardsSelected({
                          cluster: true,
                          question: true,
                        });
                      }
                    }
                  : undefined
              }
              selected={tempS ? cardsSelected.cluster : false}
           
              value={data.total_clusters}
              color="#fee2e2"
              text="#dc2626"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
             <CountChips selected={tempS ? cardsSelected.question : false}
                         
                          label="Questions"
                          value={data.total_questions}
                          color="#fef3c7"
                          text="#d97706"
                        />
          </Grid>
          <Grid item xs={6} sm={3}>
            <CountChips
              label="Weightage"
              value="33.33%"
              color="#fee2e2"
              text="black"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <CountChips
              label="Path Order"
              value={data.path_order}
              color="#fef3c7"
              text="black"
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />
        {/* Weightage & ID */}

            <Grid container spacing={2} mb={2}>
                 <Grid item xs={12} sm={6} md={6}>
                   <EllipsisText label="Path Order:" value={data.path_order} />
                   <EllipsisText
                     label="Languages:"
                     value={
                       data.languages_available
                         ? data.languages_available
                             .split(",")
                             .map((lang: string) => lang.trim())
                             .join(", ")
                         : "-"
                     }
                   />
                 </Grid>{" "}
                 <Grid item xs={12} sm={6} md={6}>
                   <EllipsisText
                     label="Show Translation:"
                     value={data.show_translation ? "Yes" : "No"}
                   />
       
                   <EllipsisText
                     label="Free Access:"
                     value={data.is_free ? "Yes" : "No"}
                   />
                 </Grid>
               </Grid>
       <CardFooter
          internal_remark={data.internal_remark}
          created_at={data.created_at}
          created_by_id={data.created_by_id}
          modified_at={data.modified_at}
          modified_by_id={data.modified_by_id}
        />
      </CardContent> {child}
    </Card>
  );
};

export default Subtopic;
